import * as React from "react"
import { DigitsButton } from "@digits-shared/DesignSystem/Button"
import colors from "@digits-shared/themes/colors"
import { BodyText } from "@digits-shared/themes/typography"
import { styled } from "styled-components"
import { FilterAccordion } from "src/shared/components/Filters/FilterAccordion"

/*
  STYLES
*/

const ContentHeader = styled.div`
  background: ${colors.secondary10};
  display: flex;
  align-items: center;
  padding: 12px 4px 12px 16px;
  border-radius: 8px 8px 0 0;
  min-height: 48px;
`

/*
  COMPONENTS
*/

interface Props {
  defaultAccordionOpen?: string
  onResetClick: () => void
  currentFiltersCount: number
  children?: React.ReactNode
}

export const FilterColumn: React.FC<Props> = ({
  defaultAccordionOpen,
  onResetClick,
  currentFiltersCount,
  children,
}) => (
  <>
    <ContentHeader>
      <BodyText weight="heavy" css="flex: 1">
        Filters
      </BodyText>
      {!!currentFiltersCount && (
        <DigitsButton size="small" onClick={onResetClick} $variant="ghost-dark">
          Clear Filters
        </DigitsButton>
      )}
    </ContentHeader>
    <FilterAccordion defaultValue={defaultAccordionOpen}>{children}</FilterAccordion>
  </>
)
